import Vue from 'vue'
import App from './App.vue'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import router from './router/router'
import store from './store/index'
import './plugins/constants_mixin'
import './plugins/google_maps'
import VueOffline from 'vue-offline'
import Debug from '@/mixins/Debug.js'


import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueScrollactive from 'vue-scrollactive'
/*import VueSocketIOExt from 'vue-socket.io-extended'
import io from 'socket.io-client'*/

/*if (process.env.NODE_ENV === 'production') {
  const socket = io(process.env.VUE_APP_SOCKET_ENDPOINT)
  // eslint-disable-next-line no-console
  console.log('check 1', socket.connected)
  socket.on('connect', function() {
    // eslint-disable-next-line no-console
    console.log('check 2', socket.connected)
  })
  socket.on('disconnect', function() {
    // eslint-disable-next-line no-console
    console.log('check 2', 'disconnect')
  })
Vue.use(VueSocketIOExt, socket)
}*/
import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)
Vue.use(VueOffline)
Vue.config.productionTip = false
Vue.router = router
Vue.use(router)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueAwesomeSwiper)
Vue.use(VueScrollactive)

// eslint-disable-next-line no-undef
Vue.use(require('vue-inputmask').default)
Vue.mixin(Debug)

window.OneSignal = window.OneSignal || []

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
